
export const ActivityLogsGetListSchema = {
    status: 'status',
    submittedDate: 'submittedDate',
    target: 'target',
    targetSchema: {
        displayValue: 'displayValue',
        value: 'value',
        type: 'type',
        typeValues: {
            gateways: 'gateways',
            users: 'users',
            administrators: 'administrators',
            servers: 'servers',
            communities: 'communities'
        }
    },
    serviceDomain: 'serviceDomain',
    action: 'action',
    details: 'details'
}

export const ActivityLogsStatuses = {
    done: 'Done',
    error: 'Failed',
    waiting: 'Waiting',
    running: 'In progress',
    canceled: 'Canceled'
}